import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { AiOutlinePauseCircle } from "react-icons/ai";
import { AiOutlineFall } from "react-icons/ai";
import { AiOutlineRise } from "react-icons/ai";
import { useStores } from "../../store"; // Ensure this path is correct and the store is properly initialized
import { StatusCardMobile } from "./TotalApplicant3";

const StatusCardShimmer = () => {
  return (
    <div className="animate-pulse">
      <div className="flex items-center">
        <div className="h-8 w-8 rounded-full bg-gray-300"></div>
        <div className="ml-2 h-6 w-24 bg-gray-300 rounded"></div>
        <div className="ml-5 h-4 w-16 bg-gray-300 rounded"></div>
        <div className="ml-2 h-4 w-20 bg-gray-300 rounded"></div>
      </div>
      <div className="h-6 w-16 bg-gray-300 rounded ml-10 mt-2"></div>
    </div>
  );
};

const TotalApplicantShimmer = () => {
  return (
    <div className="flex flex-col gap-y-7 mt-6 w-full bg-black text-white rounded-lg py-6 px-5">
      <div className="animate-pulse">
        <div className="flex gap-5">
          <div className="h-8 w-40 bg-gray-700 rounded"></div>
          <div className="h-8 w-20 bg-gray-700 rounded"></div>
        </div>
        <div className="flex w-full flex-col md:flex-row gap-y-5 justify-between gap-x-2 mt-7">
          <StatusCardShimmer />
          <div className="border-dashed border border-gray-500 ..."></div>
          <StatusCardShimmer />
          <div className="border-dashed border border-gray-500 ..."></div>
          <StatusCardShimmer />
          <div className="border-dashed border border-gray-500 ..."></div>
          <StatusCardShimmer />
        </div>
      </div>
    </div>
  );
};

const StatusCard = ({
  color,
  icon,
  title,
  count,
  percentage,
  lastMonthText,
  filter,
}) => {
  // Determine trend icon and color based on percentage
  const isPositive = parseFloat(percentage) > -0.000009;
  const trendIcon = isPositive ? (
    <AiOutlineRise className="pr-2 text-2xl" />
  ) : (
    <AiOutlineFall className="pr-2 text-2xl" />
  );
  const trendColor = isPositive ? "text-green-400" : "text-red-500";

  const { RecuiterStore } = useStores();

  return (
    <div
      onClick={() => {
        RecuiterStore.setStatus(filter);
        RecuiterStore.fetchapplicants();
        console.log("Status set to: ", RecuiterStore.status);
      }}
    >
      <div className="flex items-center ">
        <p className={`p-1 rounded-full ${color}`}>{icon}</p>
        <p className="ml-2 text-xl">{title}</p>
        <p
          className={`flex items-center whitespace-nowrap text-xs ml-5 ${trendColor}`}
        >
          {isPositive && "+"}
          {`${percentage}%`} {trendIcon}
        </p>
        <p className="flex items-center whitespace-nowrap text-xs text-white-400 ">
          {lastMonthText}
        </p>
      </div>
      <h3 className="text-lg font-semibold ml-10">{count}</h3>
    </div>
  );
};

function TotalApplicant({
  totalApplicants,
  shortListed,
  onHold,
  hired,
  rejected,
  shortlistPercentage,
  rejectPercentage,
  onHoldPercentage,
  hiredPercentage,
}) {
  const { RecuiterStore } = useStores();

  if (RecuiterStore.loader) {
    return <TotalApplicantShimmer />;
  }

  return (
    <div className="flex flex-col gap-y-7 mt-6 w-full bg-black text-white rounded-lg py-6 px-5">
      <StatusCardMobile />
      <div className="flex gap-5">
        <p className="text-2xl">Total Applicants</p>
        <p className="text-2xl font-semibold text-orange-500">
          {totalApplicants ?? "-"}
        </p>
      </div>
      <div className="flex w-full flex-col md:flex-row gap-y-5 justify-between gap-x-2 hover:cursor-pointer">
        <StatusCard
          color="bg-blue-500"
          icon={<AiOutlineCheckCircle size={22} />}
          title={
            <span className="text-lg hover:cursor-pointer">Short Listed</span>
          }
          count={shortListed ?? "-"}
          percentage={shortlistPercentage}
          lastMonthText="Last Month"
          filter={1}
        />
        <div className="border-dashed border  border-gray-500 ..."></div>
        <StatusCard
          color="bg-yellow-500"
          icon={<AiOutlinePauseCircle size={22} />}
          title={<span className="text-lg hover:cursor-pointer">On Hold</span>}
          count={onHold ?? "-"}
          percentage={onHoldPercentage}
          lastMonthText="Last Month"
          filter={0}
        />
        <div className="border-dashed border border-gray-500 ..."></div>
        <StatusCard
          color="bg-green-500"
          icon={<AiOutlineUsergroupAdd size={22} />}
          title={<span className="text-lg hover:cursor-pointer">Hired</span>}
          count={hired ?? "-"}
          percentage={hiredPercentage}
          lastMonthText="Last Month"
          filter={3}
        />
        <div className="border-dashed border border-gray-500 ..."></div>
        <StatusCard
          color="bg-red-500"
          icon={<AiOutlineCloseCircle size={22} />}
          title={<span className="text-lg hover:cursor-pointer">Rejected</span>}
          count={rejected ?? "-"}
          percentage={rejectPercentage}
          lastMonthText="Last Month"
          filter={2}
        />
      </div>
    </div>
  );
}

export default TotalApplicant;
